<template>
    <div class="layout__container">


        <div class="layout__padding-clear">

            <carousel :per-page="1" :autoplayTimeout="5000" :autoplay="true" :paginationSize="16"
                      paginationActiveColor="#00859c" :loop="true" :speed="1000" :paginationPadding="5" easing="ease">
                <!--<slide>
                  <a href="https://ravensworth.co.uk/door-drops-2026" target="_blank">
                    <div class="layout__position__relative">
                      <div class=""></div>
                      <img class="layout__width-100 layout__height-100 layout__padding-clear"
                           src="https://rpsassets.blob.core.windows.net/rpsimages/images/banners/MyRavensworthDoorDrops.jpg">
                    </div>
                  </a>
                </slide>-->
                <slide>
                    <a href="#" @click.prevent="openPopupRegister()">
                        <div class="layout__position__relative">
                            <div class=""></div>
                            <img class="layout__width-100 layout__height-100 layout__padding-clear"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/banners/SimplerFaster-banner.jpg">
                        </div>
                    </a>
                </slide>
            </carousel>
        </div>

        <div class="layout__padding-clear layout__overflow-hidden">
            <div class="layout__padding-20px layout__padding-clear layout__width-70 text__align-center">

                <h2 class="layout__padding-40px-0 text__colour-teal">Ravensworth's Top Products
                    <!-- RIFAT todo drop bold -->
                    <p class="text__colour-grey layout__padding-20-0 text__size-18">Order our most frequently purchased
                        products</p>
                </h2>

                <div class="component__forms-3 text__align-center layout__cursor-pointer">
                    <router-link class="link__colour-black" to="/products/print/stationery">
                        <div class="">
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/businesscards.jpg">
                </div>
                        <h4 class="layout__padding-20-0 colour__background-light-grey text__colour-teal text__size-20">
                            Business Cards
                        </h4>
                    </router-link>
                </div>

                <div class="component__forms-3 text__align-center layout__cursor-pointer">
                    <router-link class="link__colour-black" to="/products/print/brochures">
                        <div class="">
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/propertybrochure.jpg">
                        </div>
                        <h4 class="layout__padding-20-0 colour__background-light-grey text__colour-teal text__size-20">
                            Property Brochures
                        </h4>
                    </router-link>
                </div>

                <div class="component__forms-3 text__align-center layout__cursor-pointer">
                    <router-link class="link__colour-black" to="/products/print/window-cards-and-posters">
                        <div class="">
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/windowcards.jpg">
                        </div>
                        <h4 class="layout__padding-20-0 colour__background-light-grey text__colour-teal text__size-20">
                            Window Cards
                        </h4>
                    </router-link>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
    import Vue from 'vue';
    import Router from '../router.js';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {Carousel, Slide} from 'vue-carousel';
    import Axios from 'axios';

    Vue.use(Element);

    export default {
        name: "start",
        mixins: [axios],
        components: {
            Carousel,
            Slide
        },
        data() {
            return {}
        },
        mounted() {
            if (this.$route.query.launch === 'true') {
                this.openPopupRegister();
            }
        },
        created() {
        },
        methods: {
            navigation(path) {
                Router.push({
                    name: ''
                })
            },
            openPopupRegister() {
                Vue.nextTick(function () {
                    global.vm.$children[0].loginDialogClosable = true;

                    Vue.nextTick(function () {
                        //global.vm.$children[0].$refs.loginClosable.activePanel = 'register';
                        global.vm.$children[0].$refs.loginClosable.activeForm = 'register';
                    })
                })
            }
        }

    };
</script>